import styles from './header.module.css';

import { IconChartBar } from '@tabler/icons-react';

export default function Header() {
    return (
        <h1 className={styles.header}>
            <IconChartBar size={24} />
            Storm Strategy Survey Responses
        </h1>
    )
}